module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3b"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0002-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/F000A.jpg"
    }
  }), _vm._v("gainst the blue-black mountains, Espen’s bicycle was just a tiny moving speck. Far below the road, the river pulsed and rushed, swollen with rain and snowmelt. The sun had long ago slipped away, leaving just a thin fringe of light glimmering along the ragged edge of the western mountains. "), _c('em', [_vm._v("The dangerous time of day")]), _vm._v(", his grandmother would have said, "), _c('em', [_vm._v("the time of day the trolls come out.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Head down, straining forward over the handlebars, Espen felt his heart pump in rhythm with his legs. The muscles in his arms and legs burned, his heart beat furiously, and, ridiculously, his stomach was growling. He was always hungry. But how could he be hungry "), _c('em', [_vm._v("now?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Cream cake,” he said aloud, savoring the words as if eating them, feeling the sweet, silky “cream” melt on his tongue, then biting into the delicious sponginess of “cake.” He shouldn’t think about it, he scolded himself. He shouldn’t think about anything but going faster.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A car drove up behind him and slowed. He pedaled harder, sweating under the rucksack on his back. "), _c('em', [_vm._v("Why don’t they pass?")]), _vm._v(" he wondered. By the car’s puttering he could tell "), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _vm._v("it was not fitted with a wood-burning engine, which the Norwegians were required to drive. It burned petrol, so it had to be Germans.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Don’t look over your shoulder")]), _vm._v(", he told himself. "), _c('em', [_vm._v("If they want to stop you, they can stop you. Just don’t think about it. Think about something else. But not cream cake.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He wondered what was happening at home. His father would still be at the train station, working his usual long hours. His mother would be worrying about them both, glancing out the window one last time before pulling the blackout curtains closed. His sister, Ingrid, would be up in her room, probably scribbling in her diary.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The car pulled up alongside Espen, and he glanced at it. He felt a rivulet of sweat run down his back. The car was full of German soldiers. The driver waved at him to stop, and Espen did, standing with one foot on the ground, the other resting on the pedal. Right away, his glasses fogged up. He took them off and cleaned the lenses with his shirt. Then he gave one last thought to his family, hoping that whatever happened next would not put their lives in jeopardy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One of the soldiers got out of the car and held out his hand. “"), _c('em', [_vm._v("Ausweiss, bitte")]), _vm._v(",” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Espen dug in his pocket and handed the soldier his identity card. The soldier, Espen noticed, smelled clean. Like soap.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Where are you going?” the soldier asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“To visit my uncle. He lives near Fossen.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("“What is the purpose of your visit?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Just a visit,” Espen said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The soldier raised an eyebrow, so Espen continued. “My uncle’s been ill, and my mother’s worried about him. He doesn’t have a telephone, so I said I would go check on him.” Espen resisted the urge to go on with his story. "), _c('em', [_vm._v("Keep it simple")]), _vm._v(", he remembered Mr. Henriksen telling him. "), _c('em', [_vm._v("If they ask you questions, keep it simple. Don’t rattle on.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The soldier shone his flashlight in Espen’s face. “Out so late?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I had soccer practice,” Espen said. “We have a big match coming up. I got a late start.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How old are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Fourteen,” Espen said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The soldier nodded at Espen’s rucksack. “What’s in there?” he asked in not-very-good Norwegian.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Jam,” Espen said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The soldier extended his arm to take the rucksack.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Espen handed it over and tried not to watch the man’s face as he opened it. Instead, he shifted his gaze to the car. He could see the bored faces of the soldiers and one who turned his head. But not fast enough. Espen had seen who it was. Kjell.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They hadn’t done much together lately, but it used to be that he and Kjell had spent every waking moment with each other. Just last April, after the Germans invaded, they had spent the next days with their ears pressed to the radio and "), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("their eyes on the roads, listening, watching, waiting. And spying.")]), _vm._v(" "), _c('p', {
    staticClass: "imagen"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("The April day the German army reached their valley, Espen had followed Kjell along paths worn into the snow, leading up the hillside through the woods. All along the path rose columns of silent fir trees, their damp trunks reminding Espen of the woolen coats of the German soldiers. He half expected one to lunge out at them, bayonet flashing.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("“Aren’t you scared?” He panted a little, hurrying after Kjell.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Nei!” "), _c('em', [_vm._v("Kjell said. “It’s fun!” He turned around, grinning.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Kjell was never afraid of anything. He went toward danger, not away from it. That’s what Espen’s mother said, anyway, and why she told Espen that he had to “keep a level head” when they were together. She would have clobbered them both, Espen thought, if she knew what they were doing at that moment.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("“I have to be back before dark,” Espen said")]), _vm._v(". “Mor "), _c('em', [_vm._v("decided that she is taking Ingrid and me to stay with relatives in the country, to get away from the fighting.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("“Just this one last mission before you go, then, right?” Kjell said")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("The trees had thinned as they reached a higher elevation, and the boys dashed from one to the next")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("“This mission will be better than when you had us")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('em', [_vm._v("prowling around in the woods looking for the king,” Kjell said. “That was a bust!”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("“I swear, the whole royal family was hiding out around here somewhere,” Espen said. “They’re long gone by now. At least, I hope so.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("“Shh!” Kjell held up his hand")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("The dull roar of an airplane echoed against the mountainside")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("“German fighter!” Kjell cried. “They strafe anything that moves! Run!”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("But Espen felt as weak as if he were in a bad dream, as if his legs would not carry him")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Kjell grabbed his arm and dragged him under the cover of a cluster of birch trees")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("The plane flew over and away, and the boys got up, brushed off the snow, and moved on, leaving the trees for the open, windswept hillside. Kjell flopped down, slithering snakelike on his belly, with Espen following him closely. They crept behind a large boulder where they could see but not be seen")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Kjell held a finger to his lips, and slowly, carefully, the two boys peeked over the rock")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("In the darkening valley below, a procession of motorcycles, trucks, tanks, cars, horse-drawn wagons, marching soldiers, and soldiers on horseback snaked along the winding mountain road. The last rays of sunlight glanced off the barrels of the soldiers’ guns, their polished leather boots")]), _vm._v(", "), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('em', [_vm._v("and even, it seemed, off the brass buttons on their long gray-green coats")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Espen’s breath caught in his throat. Their sheer numbers and firepower made his stomach churn, but there was something more. Maybe it was a trick of light or the dusk, or maybe it was the fast hike up the mountainside that had made him dizzy, but for just a moment it looked to him as if the entire army was not coming from around a bend in the road but pouring endlessly out of a cleft in the earth. He thought of something his great-grandmother had told him: that sometimes, at dawn or at dusk, a crack opened up in the earth out of which the people of the underworld could climb and into which the people of the upper world—“our world,” she had said—could slide")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("He shivered.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("“Cold?” Kjell asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("“There sure are a lot of them, aren’t there?” Espen said.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("“They’re like a well-oiled machine,” Kjell said. “So precise. And so many! And no one can say the Wehrmacht isn’t disciplined! Our so-called troops are nothing but a ragtag bunch of ill-trained misfits—no uniforms, old hunting rifles for weapons—”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("“But lots of courage,” Espen said.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("“Maybe so. But still no match for them.” Kjell nodded at the never-ending columns of soldiers below")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("“If I had a rifle, I could pick off a couple right now,” Espen said")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('em', [_vm._v("“That would not be the smartest thing you’ve ever done.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("“I suppose not.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("“Look at that one there.” Kjell pointed at an officer astride a spirited white horse")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Espen glanced at Kjell. His eyes were shining as he gazed at the horse prancing this way and that, its sides gleaming as if polished")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("“Kjell,” Espen said, “you know how the")]), _vm._v(" huldre "), _c('em', [_vm._v("can look like a beautiful maiden from the front, but in the back she has a long tail she keeps tucked into her skirt?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("“We’re not troll hunting anymore, Espen,” Kjell said.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("“And how a water troll can transform himself into a beautiful jewel or even into a powerful white horse?” Espen continued")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("“This isn’t a game,” Kjell said. “This is for real.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("“I know!” Espen said. “I know. But, Kjell, once you climb onto that horse’s back, you are in its power.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("“What are you talking about?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("“It can take you away, and you can’t do anything about it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "imagen"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“You are wrong about the contents of your rucksack,” the soldier said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Espen was jolted back to the dark road, the idling car, and the soldier standing in front of him holding his backpack. “What’s that?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I said that you are wrong about what is in here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("“Oh?” Espen tried unsuccessfully to keep his voice from cracking.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This,” the German said, holding up a jar, “is "), _c('em', [_vm._v("jelly")]), _vm._v("”—he smiled—“not "), _c('em', [_vm._v("jam")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ah,” Espen said, “I always get that wrong.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“See?” the soldier shone his flashlight beam through the jar so the jelly glowed a jewel-like red. “See how clear it is? Jelly is clear—like this—and jam has in it the fruit pulp.” His Norwegian was terrible.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The soldier handed him back the rucksack, nodded politely, and went back to the car. As he moved past, Espen noticed the soap smell again. A moment later, the car puttered away. Espen could not help but smile. When the soldiers were well down the road, he thumbed his nose at the whole lot of them and let out a little howl of glee. “You were outfoxed!” he yelled at the distant taillights. Then he waited for a few moments until his legs stopped trembling before climbing back onto his bike.")]), _vm._v(" "), _c('p', {
    staticClass: "imagen"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The valley narrowed, and waterfalls plunged off the ever steeper mountainsides into the river below. Still fifteen kilometers to go. Darkness had descended; it seemed to sharpen the smell of fall, sharp and yeasty like something baking. Sour rye bread, maybe.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Espen tried to keep himself from thinking about what could go wrong and decided to think instead about the "), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v("upcoming soccer match. For the first time in as long as anyone could remember, his team had a shot—a real shot—at the championship. He wondered if Kjell would show up for the game. He hadn’t been at practices for a long time now. If he came, Espen could ask him why he’d been in a car with German soldiers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The steep climb had made Espen overheat. He stopped and took off his windcheater, which he stuffed into his rucksack. Although he couldn’t see it, he could hear the roar of a distant waterfall and the wind high in the pine boughs. Behind those sounds was the deep and abiding silence of the mountains. The silence of secrets being kept. Plenty of secrets.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Like the one he carried with him right now: two sheets of folded paper, the outside of which read, "), _c('em', [_vm._v("Growing Potatoes in Your Garden")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He climbed back onto his bike and resumed pedaling.")]), _vm._v(" "), _c('p', {
    staticClass: "imagen"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("“Be careful how you carry it,” his teacher had said when he’d given the paper to him after all his classmates had left the room that afternoon. “Best to keep it well hidden. There may be German patrols out. Seems they’re looking for—”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Suddenly, he was speaking rather loudly, “… a good way to grow potatoes in your own garden.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Espen looked up. One of his classmates had entered the")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('em', [_vm._v("room. She walked over to her desk and picked up a book, then waved at them and went back out")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("“Don’t tell anyone what you’re doing,” Mr. Henriksen had said. “Not your sister, not your classmates—not even Kjell.”")])]), _vm._v(" "), _c('p', {
    staticClass: "imagen"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("So he hadn’t told anyone. Not his sister, not his classmates, not even his parents. And not Kjell. He hadn’t even seen Kjell. Not for days, at least.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When Espen and his sister had returned to Lilleby in June after their stay in the country, Kjell was … different. It had been less than two months, but he had changed. But then, everything had changed. The Germans had taken over Norway, and nothing was the same as before.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now there were so many secrets. Kjell must have a secret, too, Espen thought. Otherwise, why was he in that car?")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1c385f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 84
// module chunks = 0